import { StructureBlockMetadata as StructureBlockMetadataBase } from '@max/tiptap-extensions'
import { VueNodeViewRenderer } from '@tiptap/vue-2'
import StructureBlockMetadataNodeView from '@/components/editor/StructureBlockMetadataNodeView'

export const StructureBlockMetadata = StructureBlockMetadataBase.extend({
    addNodeView () {
        return VueNodeViewRenderer(StructureBlockMetadataNodeView)
    },
})
